import React, { createContext, useContext, useCallback } from "react";
import { injectIntl } from "react-intl";

const IntlContext = createContext(null);

const IntlContextProvider = injectIntl(({ intl, children }) => {
  return <IntlContext.Provider value={intl}>{children}</IntlContext.Provider>;
});

export function useTranslation() {
  const intl = useContext(IntlContext);

  const t = useCallback(
    (id, values = {}) => {
      if (!id) return "";

      if (intl && intl.formatMessage) {
        return intl.formatMessage({ id, defaultMessage: id }, values);
      }
      return id;
    },
    [intl]
  );

  return { t };
}

export { IntlContextProvider };
